import {naturalSort} from '@benchling/js-utils';
import React from 'react';

import {REACTION_EXTENSIONS, EXPORT_DISPLAY_NAME, CHEMICAL_EXTENSIONS} from 'chemistry/ChemistryConstants';
import {MarvinChemicalFormat} from 'chemistry/marvinjs-wrappers/MarvinJSConstants';
import getTestProps from 'test/lib/cypress/getTestProps';
import Col from 'ui-library/bs/Col';
import FormGroup from 'ui-library/bs/FormGroup';
import Row from 'ui-library/bs/Row';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';

export interface ChemicalSketcherModalInputFieldsProps {
  filename?: string;
  setFilename: (filename: string) => void;
  saveFormat: MarvinChemicalFormat;
  setSaveFormat: (format: MarvinChemicalFormat) => void;
  isReaction: boolean;
}

export default function ChemicalSketcherModalInputFields({
  filename,
  setFilename,
  saveFormat,
  setSaveFormat,
  isReaction,
}: ChemicalSketcherModalInputFieldsProps): JSX.Element {
  let validExtensions = isReaction ? REACTION_EXTENSIONS : CHEMICAL_EXTENSIONS;
  validExtensions = naturalSort(validExtensions);
  const formatErrorText = !validExtensions.includes(saveFormat)
    ? `${EXPORT_DISPLAY_NAME[saveFormat]} is not supported for chemical reactions. Please choose a different file format to continue.`
    : '';
  const saveFormatOptions = validExtensions.map((item, index) => (
    <Option
      value={item}
      key={index}
      onSelect={(value: MarvinChemicalFormat) => {
        setSaveFormat(value);
      }}
    >
      {EXPORT_DISPLAY_NAME[item]}
    </Option>
  ));

  return (
    <Row>
      <Col sm={6}>
        <FormGroup>
          <FieldLabel label="Name" isRequired={true} />
          <input
            autoFocus={false}
            type="text"
            value={filename}
            placeholder="Untitled chemical"
            onChange={(e) => {
              setFilename(e.target.value);
            }}
            {...getTestProps({component: 'ChemicalSketcherModal', element: 'inputFields', key: 'filename'})}
          />
        </FormGroup>
      </Col>
      <Col sm={6}>
        <FieldLabel label="Format" isRequired={true} />
        <FormGroup>
          <SelectDropdown
            menu={
              <Menu height={Menu.HEIGHTS.MEDIUM} width={Menu.WIDTHS.FULL} value={saveFormat}>
                {saveFormatOptions}
              </Menu>
            }
            displayName={EXPORT_DISPLAY_NAME[saveFormat]}
            error={formatErrorText}
          />
        </FormGroup>
      </Col>
    </Row>
  );
}
